import * as React from "react";
import { Badge } from "@volca/ui/components/ui/badge";
import { Text } from "@volca/ui/components/ui/text";
import { cn } from "@volca/ui/lib/utils";

interface AutomationBadgeProps {
  className?: string;
}

export const AutomationBadge: React.FC<AutomationBadgeProps> = ({
  className,
}) => (
  <Badge variant="secondary" className={cn("gap-2", className)}>
    <Text variant="caption">Automation</Text>
  </Badge>
);

AutomationBadge.displayName = "AutomationBadge";
